import React from 'react';

// Presentational placeholder that mirrors JobCard's box/lines so the layout
// does not jump when real cards replace it. Hidden from assistive tech.
const JobCardSkeleton: React.FC = () => (
  <div className="job-card-skeleton" aria-hidden="true">
    <div className="job-card-skeleton__block">
      <div className="job-card-skeleton__title" />
      <div className="job-card-skeleton__location" />
      <div className="job-card-skeleton__salary" />
      <div className="job-card-skeleton__time" />
    </div>
  </div>
);

export default JobCardSkeleton;
